import { render, staticRenderFns } from "./ModalUploadPecas.vue?vue&type=template&id=57090880&"
import script from "./ModalUploadPecas.vue?vue&type=script&lang=js&"
export * from "./ModalUploadPecas.vue?vue&type=script&lang=js&"
import style0 from "./ModalUploadPecas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports